export const COLORS = {
  DARK_BLUE: '#434554',
  EMERALD_GREEN: '#4db3a4',
};
